import dedent from 'ts-dedent'
import { SelectWorkflowComponent } from './common/selectcomponent'
import {
  Provider,
  WorkflowComponentParamType,
  WorkflowComponentParameterMode,
  WorkflowComponentCodeParams
} from '../types'

class Transpose extends SelectWorkflowComponent {
  constructor() {
    super(
      {
        name: 'native.transpose',
        group: 'Data Preparation',
        title: 'Transpose / Unpivot',
        description: `This component unpivots the orientation of the data table.`
      },
      [
        {
          name: 'source',
          type: WorkflowComponentParamType.InputTable,
          title: 'Source table'
        },
        {
          name: 'keycols',
          type: WorkflowComponentParamType.Column,
          title: 'Key columns',
          parent: 'source',
          mode: WorkflowComponentParameterMode.Multiple,
          optional: true
        },
        {
          name: 'datacols',
          type: WorkflowComponentParamType.Column,
          title: 'Data columns',
          parent: 'source',
          mode: WorkflowComponentParameterMode.Multiple
        }
      ]
    )
  }

  getInnerSql({ params, connection, envVars }: WorkflowComponentCodeParams) {
    const keycols = [
      ...((params.keycols as Array<String>) ?? []),
      'key',
      'value'
    ].join(', ')
    switch (connection.type) {
      case Provider.Postgres:
        return dedent`
                SELECT ${keycols}
                FROM ${connection.quoteName(params.source as string)} c
                CROSS JOIN LATERAL (
                  VALUES
                    ${(params.datacols as Array<String>)
                      .map((x) => `('${x}', c.${x})`)
                      .join(',\n')}
                ) AS t(key, value) `
      case Provider.BigQuery:
      case Provider.Snowflake:
      case Provider.Redshift:
        return dedent`
                SELECT
                  ${keycols}
                FROM ${connection.quoteName(params.source as string)}
                  UNPIVOT (
                    value FOR key IN (
                      ${(params.datacols as Array<String>).join(',')}
                    )
                  )`
      case Provider.DatabricksRest:
        return dedent`
                SELECT /*+ REPARTITION(40) */
                  ${keycols}
                FROM ${connection.quoteName(params.source as string)}
                  UNPIVOT (
                    value FOR key IN (
                      ${(params.datacols as Array<String>).join(',')}
                    )
                  )`
    }
  }
}

export { Transpose }
